const Const = {
    /* Names */
    sAppName: 'FlowHero',
    sTasks: 'Tasks',
    sNotes: 'Notes',
    sSignIn: 'SignIn',
    s1on1Meetings: 'One on Ones',
    sMeetings: 'Meetings',
    s1on1s: 'OneOnOnes',
    sInterviews: 'Interviews',
    sFeedback: 'Feedback',
    sProfile: 'Profile',
    sAdmin: 'Admin',
    sPositionName: 'Position: Name',
    sOther: 'Other',
    /* Keys */
    sTitle: 'title',
    sBody: 'body',
    sGroup: 'group',
    sDescription: 'description',
    sDone: 'done',
    sOpen: 'open',
    sStatus: 'status',
    sEpicId: 'epicId',
    sRank: 'rank',
    sGlobal: 'global',
    sLocal: 'local',
    sInterview: 'interview',
    sTemplate: 'template',
    sCenter: 'center',
    sNone: 'none',
    HttpPost: 'POST',
    HttpPatch: 'PATCH',
    HttpDelete: 'DELETE',
    HttpPut: 'PUT',
    AppJson: 'application/json',
    ContentType: 'Content-Type',
    sAgents: 'Agents',
    sAgentsPath: '/agents',
    sAgentsRunPath: '/agents/run',
    sAgentsOutputsPath: '/agents/outputs',
    sInterviewsPath: '/interviews',
    sMeetingsPath: '/meetings',
    sMeetingsNotesPath: '/meetings/notes',
    sMeetingsCheckablesPath: '/meetings/checkables',
    sFeedbacksPath: '/feedbacks',
    sDefault: 'default',
    SNone: 'none',
    sPointer: 'pointer',
    sAgenda: 'agenda',
    sAction: 'action',
    sEnter: 'Enter',
    sFeature: 'feature',
    sMeeting: 'meeting',
    s1on1: '1on1',
    sTodo: 'Todo',
    sInProgress: 'In Progress',
    sDoneUp: 'Done',
    sCatchUpModal: 'CatchUpModal',
    sTaskDetailsBar: 'TaskDetailsBar',
    sImportance: 'importance',
    sUrgency: 'urgency',
    sHigh: 'High',
    sLow: 'Low',
    /* Sizes */
    XXS: 10,
    XS: 'xs',
    SM: 'sm',
    MD: 'md',
    LG: 'lg',
    XL: 'xl',
    Bold: 'bold',
    Left: 'left',
    KTaskDetailsBarW: '440px',
    /* Spacing (Chakra numeric scale: 1 = 4px) */
    SpaceXS: 1,       // 4px  — label margins, tight gaps
    SpaceSM: 2,       // 8px  — component gaps, small padding
    SpaceMD: 3,       // 12px — card/panel padding
    SpaceLG: 5,       // 20px — page/section padding
    /* Agent avatars */
    kAgentAvatars: [
        'avatar-01', 'avatar-02', 'avatar-03', 'avatar-04',
        'avatar-05', 'avatar-06', 'avatar-07', 'avatar-08',
        'avatar-09', 'avatar-10', 'avatar-11', 'avatar-12',
    ],
    /* Component defaults */
    kPadding: 3,           // 12px
    kSpacing: 1,           // 4px
    kButtonHeight: 6,      // 24px
    /* Colors */
    White: '#f6f6f6',
    ActiveColor: '#db4a2b',
    ActiveLightColor: '#d95c40',
    DoneColor: '#22543D',
    DoneLightColor: '#276749',
    SelectColor: '#3182CE',
    Red500: '#E53E3E',
    Red600: '#C53030',
    Red700: '#9B2C2C',
    // Red-tinted counterparts of Gray36/Gray46, for cards that are both
    // high importance and high urgency.
    CriticalBg: '#2f2020',
    CriticalBgHover: '#3b2727',
    Gray31: '#1f1f1f',
    Gray36: '#242424',
    Gray46: '#2e2e2e',
    Gray64: '#404040',
    Gray69: '#454545',
    Gray100: '#646464',
    Gray165: '#a5a5a5',
    Gray180: '#b4b4b4',
    Green500: '#38A169',
    Orange400: '#ED8936',
    /* Texts */
    sAISummary: 'AI Summary',
    sCreateInterviewTemplate: 'Create your own interview template.\n\n  1. Set the position title at the top.\n  2. Add the template content here.\n  3. Create interviews with one click from the template.',
    sCreateInterview: 'Create blank interview.\n\n  1. Add position title and candidate\'s name at the top.\n  2. Type notes here during the interview or copy/past the interview transcript.\n  3. Use one click AI Summary to spend 10 seconds instead of an hour for high quality interview summary.\n  4. Copy/past the summary into your candidate tracking system.'
};
  
export default Const;
